module.exports = __webpack_public_path__ + "img/nigeria-flag.3a65a5d5.svg";